const doc = [({"SEO":({"title":"Errore", "description":"Torna in home e continua a navigare su Dove.it"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;